import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import type { LocaleDefinition, LocaleNoParams } from '@gov-nx/core/types';

type RezaSwitcherLocaleDefinition = {
	table: {
		description: LocaleNoParams;
		'error-banner': {
			title: LocaleNoParams;
			text: LocaleNoParams;
		};
	};
	row: {
		label: {
			nazev: LocaleNoParams;
			ico: LocaleNoParams;
			'adresa-sidla': LocaleNoParams;
			prijmeni: LocaleNoParams;
			jmeno: LocaleNoParams;
			'datum-narozeni': LocaleNoParams;
			'adresa-pobytu': LocaleNoParams;
		};
	};
	modal: {
		title: {
			'change-reza': LocaleNoParams;
		};
	};
	form: {
		label: {
			role: LocaleNoParams;
			'reza-code': LocaleNoParams;
		};
		error: {
			'role-required': LocaleNoParams;
			'reza-code-required': LocaleNoParams;
		};
		option: {
			'role-without-representation': LocaleNoParams;
			'role-with-representation': LocaleNoParams;
		};
		select: {
			'reza-code-select': LocaleNoParams;
		};
		message: {
			'representation-not-allowed': LocaleNoParams;
			'representation-list-not-found': LocaleNoParams;
		};
		button: {
			submit: LocaleNoParams;
		};
	};
	button: {
		'change-reza': LocaleNoParams;
	};
};

export type UseRezaSwitcherLocaleType =
	LocaleDefinition<RezaSwitcherLocaleDefinition>;

export const useRezaSwitcherLocale = (): UseRezaSwitcherLocaleType =>
	useLocale(LocalizeNameSpaceTypes.Form);
